import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { makeSelectProductFieldValue } from 'services/products/selectors';

const selectWithholdingPeriodDays = createDeepEqualSelector(
    makeSelectProductFieldValue('witholdingPeriodDays'),
    (reEntryPeriodDays: number) => reEntryPeriodDays
);

const makeSelectWithholdingPeriodDays = (): typeof selectWithholdingPeriodDays =>
    selectWithholdingPeriodDays;

export { makeSelectWithholdingPeriodDays };
